import { useState } from "react";

import { ByTypeTable } from "./ByTypeTable";
import { AssetDetail } from "../AssetDetail/AssetDetail";

export const ByType = ({ isList, setIsList }) => {
  const [id, setId] = useState();

  return (
    <>
      {
        isList ? (
          <div>
            <ByTypeTable
              name="Batteries"
              type="battery"
              showActionButtons={true}
              setId={setId}
              setIsList={setIsList}
            />
            <ByTypeTable
              name="EV Charging"
              type="ev"
              setId={setId}
              setIsList={setIsList}
            />
            <ByTypeTable
              name="Solar"
              type="solar"
              setId={setId}
              setIsList={setIsList}
            />
          </div>
        ) : (
          <AssetDetail
            id={id}
            setIsList={setIsList}
          />
        )
      }
    </>
  )
}
